import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

export const LoginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Si el usuario no está autenticado, redirigir al login
  if (!authService.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  if (sessionStorage.getItem('chgpass') === 'S') {
    router.navigate(['/login/verificar']);
    return false;
  }

  return true;
};
